import React, { useState } from 'react';
import __ from 'utils/i18n';
import { getConfig } from 'config';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Col,
  Row,
  Card,
  CardBody,
  CardText
} from "reactstrap";

export const HowToModal = () => {

  const [showModal, setShowModal] = useState(false);
  const hideModal = () => setShowModal(false)
  const openModal = () => setShowModal(true)

  const imgs = getConfig('customConfig.standalone.howToModal') || {};

  const steps = [
    {
      number: 1,
      text: __("dashboard.sections.standalone.modal.seccionStandalone"),
      img: imgs.seccionImg || null,
    },
    {
      number: 2,
      text: __("dashboard.sections.standalone.modal.vinculationStandalone"),
      img: imgs.vinculationImg || null,
    },
    {
      number: 3,
      text: __("dashboard.sections.standalone.modal.statesStandalone"),
      img: imgs.statesImg || null,
    },
  ];

  return (
    <>
      <Modal
        isOpen={showModal}
        toggle={hideModal}
        zIndex={1000000}
        size={'lg'}
      >
        <ModalHeader className="text-center justify-content-center text-dark">
          {__("dashboard.sections.standalone.modal.title.howToVinculate")}
        </ModalHeader>
        <ModalBody className="pb-3">
          <Row className="justify-content-center" noGutters>
            {steps.map((step, index) => (
              <Col md={4} key={index} className="mb-4 d-flex flex-column align-items-center">
                <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mb-2" style={{ width: 32, height: 32, fontWeight: 'bold' }}>
                  {step.number}
                </div>
                <Card className="w-100 h-100 border-0 shadow-sm">
                  <CardBody className="px-3 pb-2">
                    <CardText className="text-start text-dark">
                      {step.text}
                    </CardText>
                  </CardBody>
                  <div className="text-center px-3 pb-3">
                    <img
                      src={step.img}
                      alt={step.text}
                      style={{ width: '100%', height: '200px', objectFit: 'contain' }}
                    />
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </ModalBody>
        <ModalFooter className="justify-content-center pb-3">
          <Button color="primary" onClick={hideModal} style={{ padding: '0.6rem 2rem', fontWeight: '500' }}>
            {__('dashboard.components.modal.btnClose') || 'Cerrar'}
          </Button>
        </ModalFooter>
      </Modal>

      <Button
        color="link"
        onClick={openModal}
        className="p-0"
      >
        ¿Cómo vinculo mi dispositivo?
      </Button>
    </>
  );
};
